const routes = [
  { 
    path: '/', 
    name: 'Inicio', 
    component: () => import('./paginas/visitas/inicio/Inicio.vue'), 
    meta: { mainComponent: 'Inicio', title: 'NO + TOC' }
  },
  { 
    path: '/acerca', 
    name: 'Acerca', 
    component: () => import('./paginas/visitas/acerca/Acerca.vue'), 
    meta: { mainComponent: 'Acerca', title: 'NO + TOC · Acerca de mí' }
  },
  { 
    path: '/terapia', 
    name: 'Terapia', 
    component: () => import('./paginas/visitas/terapia/Terapia.vue'), 
    meta: { mainComponent: 'Terapia', title: 'NO + TOC · Acerca de la terapia' }
  },
  { 
    path: '/preguntas', 
    name: 'Preguntas', 
    component: () => import('./paginas/visitas/preguntas/Preguntas.vue'), 
    meta: { mainComponent: 'Preguntas', title: 'NO + TOC · Preguntas frecuentes' }
  },
  { 
    path: '/contacto', 
    name: 'Contacto', 
    component: () => import('./paginas/visitas/contacto/Contacto.vue'), 
    meta: { mainComponent: 'Contacto', title: 'NO + TOC · Contacto' }
  },
  { 
    path: '/informacion', 
    name: 'Informacion', 
    component: () => import('./paginas/visitas/informacion/Informacion.vue'), 
    meta: { mainComponent: 'Informacion', title: 'NO + TOC · Información del TOC' }
  },
  { 
    path: '/articulos', 
    name: 'Articulos', 
    component: () => import('./paginas/visitas/articulos/Articulos.vue'), 
    meta: { mainComponent: 'Articulos', title: 'NO + TOC · Artículos de TOC' }
  },
  { 
    path: '/articulo/:nombre_articulo', 
    name: 'Articulo', 
    component: () => import('./paginas/visitas/articulos/Articulo.vue'), 
    meta: { mainComponent: 'Articulo', title: 'NO + TOC · Artículo' }
  },
  { 
    path: '/:catchAll(.*)', 
    name: 'NotFound', 
    component: () => import('./404.vue'), 
    meta: { mainComponent: 'NotFound', title: 'NO + TOC · Página no encontrada' }
  },
  {
    path: '/quiero-terapia',
    name: 'Quiero Terapia',
    component: () => import('./paginas/visitas/quiero-terapia/Quiero-Terapia.vue'),
    meta: { mainComponent: 'Quiero Terapia', title: 'NO + TOC · Quiero terapia' }
  }
];

export default routes;
